import { render, staticRenderFns } from "./sex-selector.vue?vue&type=template&id=4b47c760&scoped=true&"
import script from "./sex-selector.vue?vue&type=script&lang=js&"
export * from "./sex-selector.vue?vue&type=script&lang=js&"
import style0 from "./sex-selector.vue?vue&type=style&index=0&id=4b47c760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47c760",
  null
  
)

export default component.exports